import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./CriarCobranca.css";

export default function CriarCobrancaAtualizado() {
  const location = useLocation();
  const dadosCliente = location.state || {};

  const [clientes, setClientes] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");

  const [responsavel, setResponsavel] = useState("");
  const [whatsappMessage, setWhatsappMessage] = useState("");

  const [usuarioId, setUsuarioId] = useState("");
  const [valor, setValor] = useState(() =>
    dadosCliente.valor ? String(dadosCliente.valor).replace(",", ".") : "0"
  );
  const [tipoPagamento, setTipoPagamento] = useState(
    dadosCliente.forma_pagamento || "BOLETO"
  );
  const [vencimento, setVencimento] = useState("");

  const [descricaoTipo, setDescricaoTipo] = useState(
    "Mensalidade Nórea Marketing Especializado"
  );
  const [descricaoOutra, setDescricaoOutra] = useState("");

  useEffect(() => {
    async function fetchClientes() {
      try {
        const response = await fetch(
          "https://welaunchyou.com.br/crm-wly/listagem_usuarios.php"
        );
        const data = await response.json();

        if (Array.isArray(data.usuarios)) {
          setClientes(data.usuarios);

          if (dadosCliente.nome_empresa) {
            const clienteEncontrado = data.usuarios.find(
              (c) => c.nome_empresa === dadosCliente.nome_empresa
            );

            if (clienteEncontrado) {
              setUsuarioId(clienteEncontrado.id);
              setResponsavel(clienteEncontrado.responsavel || "Cliente");
            }
          }
        } else {
          console.error("Erro: Resposta inesperada da API", data);
        }
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
      }
    }

    fetchClientes();
  }, [dadosCliente]);

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setStatus("");

    const descricaoFinal =
      descricaoTipo === "Outra" ? descricaoOutra.trim() : descricaoTipo;

    if (!descricaoFinal) {
      setStatus("Preencha a descrição da cobrança.");
      setLoading(false);
      return;
    }

    const dadosCobranca = {
      usuario_id: usuarioId,
      valor: parseFloat(valor) || 0,
      tipo_pagamento: tipoPagamento,
      vencimento: vencimento,
      pacote: "MENSAL",
      descricao: descricaoFinal,
    };

    try {
      console.log("📌 Enviando cobrança:", dadosCobranca);

      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/api/integracoes/gerar_cobranca_asaas.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dadosCobranca),
        }
      );

      const resultado = await response.json();

      if (resultado.success) {
        setPaymentLink(resultado.payment_link);
        setStatus("Cobrança criada com sucesso!");
        setResponsavel(resultado.responsavel || "Cliente");

        const nowBrasilia = new Date(
          new Date().toLocaleString("en-US", {
            timeZone: "America/Sao_Paulo",
          })
        );

        const hora = nowBrasilia.getHours();
        const saudacao = hora < 12 ? "Ótimo dia" : "Ótima tarde";
        const nome = resultado.responsavel || "Cliente";

        // pegar mês atual
        const meses = [
          "janeiro",
          "fevereiro",
          "março",
          "abril",
          "maio",
          "junho",
          "julho",
          "agosto",
          "setembro",
          "outubro",
          "novembro",
          "dezembro",
        ];

        const mesAtual = meses[nowBrasilia.getMonth()];

        const mensagemTexto =
          `${saudacao} ${nome}, como vai?\n\n` +
          `Segue o link da cobrança de ${mesAtual} referente a ${descricaoFinal}:\n` +
          `${resultado.payment_link}\n\n` +
          `Qualquer dúvida estou à disposição 😊`;

        setWhatsappMessage(mensagemTexto);

        setUsuarioId("");
        setValor("");
        setTipoPagamento("BOLETO");
        setVencimento("");
        setDescricaoTipo("Mensalidade Nórea Marketing Especializado");
        setDescricaoOutra("");

        setTimeout(() => setStatus(""), 5000);
      } else {
        setStatus("Erro ao criar cobrança: " + (resultado.error || "Erro desconhecido"));
      }
    } catch (error) {
      console.error("Erro ao criar cobrança:", error);
      setStatus("Erro ao criar cobrança.");
    } finally {
      setLoading(false);
    }
  }

  const copiarMensagem = () => {
    navigator.clipboard.writeText(whatsappMessage);
    alert("Mensagem copiada para a área de transferência!");
  };

  return (
    <div className="pagina-criar-cobranca">
      <h1 className="titulo-criar-cobranca">Criar Nova Cobrança</h1>

      <div className="container-criar-cobranca">
        <form onSubmit={handleSubmit} className="formulario-criar-cobranca">
          <label>Cliente:</label>
<select
  value={usuarioId}
  onChange={(e) => {
    const idSelecionado = e.target.value;
    setUsuarioId(idSelecionado);

    const clienteSelecionado = clientes.find(
      (cliente) => String(cliente.id) === String(idSelecionado)
    );

    if (clienteSelecionado) {
      setValor(
        clienteSelecionado.mensalidade
          ? String(clienteSelecionado.mensalidade).replace(",", ".")
          : "0"
      );

      setResponsavel(clienteSelecionado.responsavel || "Cliente");
    }
  }}
  required
>
  <option value="">Selecione um cliente</option>
  {clientes.map((cliente) => (
    <option key={cliente.id} value={cliente.id}>
      {cliente.nome_empresa ? cliente.nome_empresa : "Nome não informado"}
    </option>
  ))}
</select>

          <label>Valor (R$):</label>
          <input
            type="number"
            step="0.01"
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            required
          />

          <label>Forma de Pagamento:</label>
          <select
            value={tipoPagamento}
            onChange={(e) => setTipoPagamento(e.target.value)}
          >
            <option value="BOLETO">Boleto</option>
            <option value="PIX">PIX</option>
            <option value="CREDIT_CARD">Cartão de Crédito</option>
          </select>

          <label>Data de Vencimento:</label>
          <input
            type="date"
            value={vencimento}
            onChange={(e) => setVencimento(e.target.value)}
            required
          />

          <label>Descrição da Cobrança:</label>
          <select
            value={descricaoTipo}
            onChange={(e) => setDescricaoTipo(e.target.value)}
            required
          >
            <option value="Mensalidade Nórea Marketing Especializado">
              Mensalidade Nórea Marketing Especializado
            </option>
            <option value="Nórea Produção Audiovisual">
              Nórea Produção Audiovisual
            </option>
            <option value="Nórea CRM Mensalidade">
              Mensalidade Nórea CRM
            </option>
            <option value="Outra">Outra</option>
          </select>

          {descricaoTipo === "Outra" && (
            <>
              <label>Digite a descrição:</label>
              <input
                type="text"
                value={descricaoOutra}
                onChange={(e) => setDescricaoOutra(e.target.value)}
                placeholder="Ex: Serviço avulso de edição"
                required
              />
            </>
          )}

          <button
            type="submit"
            disabled={loading}
            className="botao-criar-cobranca"
          >
            {loading ? "Criando..." : "Criar"}
          </button>
        </form>

        {status && <p className="mensagem-status">{status}</p>}

        {paymentLink && (
          <div className="whatsapp-container">
            <p>Mensagem para enviar pelo WhatsApp:</p>
            <textarea readOnly value={whatsappMessage}></textarea>

            <div className="whatsapp-buttons">
              <button onClick={copiarMensagem} className="botao-copiar">
                Copiar
              </button>

              <a
                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                  whatsappMessage
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="botao-whatsapp"
              >
                💬 Enviar no WhatsApp
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}